import { render, staticRenderFns } from "./addHistory.vue?vue&type=template&id=c8939da0"
import script from "./addHistory.vue?vue&type=script&lang=js"
export * from "./addHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports